export default {
	// Die fachlichen Regeln der Dialoge. Alles Allgemeine - `required`, `tooLong`,
	// `invalidEmail` und die anderen Regeln aus lib/js/utils/validations.ts - kommt aus der lib;
	// `tooManyLines` steht hier nur, weil die Zahl in der Meldung mehr sagt als "zu viele".
	validations: {
		died_before_born: 'Sterbedatum liegt vor dem Geburtsdatum',
		share_incomplete: 'Zähler und Nenner gehören zusammen',
		too_many_lines: 'Höchstens sechs Zeilen',
		key_format: 'Nur Kleinbuchstaben, Ziffern und _',
	},

	// Labels of the filter components under resources/js/components/filter/, which sit above
	// more than one screen and belong to none of them.
	filters: {
		location: 'Standort',
		location_none: 'Ohne Standort',
		tag: 'Tag',
	},

	sidebar: {
		dashboard: 'Dashboard',
		pipeline: 'Onboarding',
		law_firms: 'Kanzleien',
		matters: 'Fälle',
		tasks: 'Aufgaben',
		calendar: 'Kalender',
		// The shared notebook. The tab labels of the per record ones are under tabs.*.
		notes: 'Notizen',
		crm_header: 'Mandanten',
		work_header: 'Fallarbeit',
		admin_header: 'Administration',
		users: 'Benutzer',
		locations: 'Standorte',
		correspondence_templates: 'Vorlagen',
		tags: 'Tags',
	},

	tabs: {
		law_firm: {
			overview: 'Übersicht',
			onboarding: 'Onboarding',
			tasks: 'Aufgaben',
			contacts: 'Ansprechpartner',
			matters: 'Fälle',
			communications: 'Schriftverkehr',
			log: 'Kontaktverlauf',
			notes: 'Notizen',
		},
		matter: {
			overview: 'Übersicht',
			tree: 'Stammbaum',
			tasks: 'Aufgaben',
			documents: 'Dateien',
			log: 'Kontaktverlauf',
			notes: 'Notizen',
		},
	},

	buttons: {
		task: {
			create: 'Aufgabe anlegen',
			edit: 'Aufgabe bearbeiten',
			delete: 'Aufgabe löschen',
			complete: 'Als erledigt markieren',
			reopen: 'Wieder öffnen',
		},
		law_firm: {
			create: 'Kanzlei anlegen',
			edit: 'Kanzlei bearbeiten',
			delete: 'Kanzlei löschen',
			open: 'Kanzlei öffnen',
		},
		contact: {
			create: 'Ansprechpartner anlegen',
			edit: 'Ansprechpartner bearbeiten',
			delete: 'Ansprechpartner löschen',
		},
		location: {
			create: 'Standort anlegen',
			edit: 'Standort bearbeiten',
			delete: 'Standort löschen',
		},
		matter: {
			create: 'Fall anlegen',
			edit: 'Fall bearbeiten',
			delete: 'Fall löschen',
			open: 'Fall öffnen',
			close: 'Fall abschließen',
			reopen: 'Fall wieder öffnen',
		},
		person: {
			create: 'Person anlegen',
			edit: 'Person bearbeiten',
			delete: 'Person löschen',
			add_parent: 'Elternteil verknüpfen',
			remove_parent: 'Verknüpfung lösen',
		},
		document: {
			create: 'Datei hochladen',
			edit: 'Datei bearbeiten',
			delete: 'Datei löschen',
			open: 'Datei öffnen',
			preview: 'Datei ansehen',
		},
		interaction: {
			create: 'Eintrag anlegen',
			edit: 'Eintrag bearbeiten',
			delete: 'Eintrag löschen',
		},
		correspondence_template: {
			create: 'Vorlage anlegen',
			edit: 'Vorlage bearbeiten',
			delete: 'Vorlage löschen',
		},
		tag: {
			create: 'Tag anlegen',
			edit: 'Tag bearbeiten',
			delete: 'Tag löschen',
		},
		communication: {
			create: 'Schreiben anlegen',
			edit: 'Schreiben bearbeiten',
			delete: 'Schreiben löschen',
			generate: 'Aus Vorlage entwerfen',
			generate_outreach: 'Anschreiben entwerfen',
			view: 'Ansehen',
			print: 'Drucken',
			pdf: 'Als PDF herunterladen',
			// The print view's toolbar, the long label as its hint
			review: 'Freigeben',
			mark_sent: 'Als versendet vermerken',
			mark_sent_short: 'Versendet',
			download_short: 'Herunterladen',
			unsend: 'Versand zurücknehmen',
		},
		tree: {
			zoom_in: 'Vergrößern',
			zoom_out: 'Verkleinern',
			reset: 'Ansicht zurücksetzen',
			print: 'Chart drucken',
		},
		onboarding: {
			create: 'Schritt hinzufügen',
			toggle: 'Schritt abhaken',
		},
	},

	pages: {
		dashboard: {
			title: 'Dashboard',
			pipeline: 'Onboarding-Pipeline',
			my_tasks: 'Meine Aufgaben',
			follow_ups: 'Wiedervorlagen',
			deadlines: 'Fristen',
			my_matters: 'Meine Fälle',
			matters_by_state: 'Fälle nach Status',
			empty: 'Nichts offen.',
		},
		tasks: {
			title: 'Aufgaben',
			subtitle: 'Alle Aufgaben, gefiltert nach Zuständigkeit und Status.',
			mine: 'Mir zugewiesen',
			all: 'Alle',
			all_states: 'Alle',
			open: 'Offen',
			done: 'Erledigt',
			overdue: 'Überfällig',
			unassigned: 'Nicht zugewiesen',
			no_subject: 'Ohne Bezug',
			empty: 'Keine Aufgaben.',
			empty_open: 'Nichts offen.',
			completed_by: 'Erledigt von {name} am {date}',
		},
		communication_print: {
			subject_label: 'Betreff:',
			archived: 'Archivierte Fassung vom {date}',
			not_archived: 'Keine archivierte Fassung - gezeigt mit dem heutigen Briefpapier',
		},
		correspondence_templates: {
			title: 'Schriftverkehr-Vorlagen',
			subtitle: 'Die Vorlagen, aus denen im Schriftverkehr einer Kanzlei ein Entwurf entsteht.',
			empty: 'Noch keine Vorlage angelegt.',
			hint: 'Ein Entwurf übernimmt Betreff, Text und PS dieser Vorlage; Anschrift, Anrede und Briefpapier kommen aus der Kanzlei. Eine Änderung hier gilt für neue Entwürfe, nicht für bereits geschriebene.',
			locked: 'Das Anschreiben wird beim Anlegen einer Kanzlei und beim Import verwendet und lässt sich nicht löschen.',
		},
		tags: {
			title: 'Tags',
			subtitle: 'Womit eine Kanzlei markiert wird: in der Liste als Filter, in der Pipeline auf der Karte.',
			empty: 'Noch kein Tag angelegt.',
			failed: 'Die Tags konnten nicht geladen werden.',
			hint: 'Der Recherche-Import setzt Tags über ihren Schlüssel und entscheidet anhand der Beschreibung, wann einer zutrifft. Der Schlüssel entsteht beim Anlegen aus dem Namen, wenn keiner angegeben ist, und lässt sich ändern.',
		},
		locations: {
			title: 'Standorte',
			subtitle: 'Die Büros von proERBE. Ein Standort wird an der Kanzlei ausgewählt.',
			empty: 'Noch kein Standort angelegt.',
			hint: 'Der Standort einer Kanzlei gilt auch für deren Fälle und bestimmt die Absendeadresse ihrer Briefe. Ein Standort mit Kanzleien lässt sich nicht löschen.',
			preview: 'Briefpapier des Standorts',
			preview_hint:
				'Die Zeile im Adressfeld und der Ort vor dem Datum kommen aus diesem Standort, alles andere aus dem gemeinsamen Briefpapier.',
		},
		letterhead: {
			title: 'Briefpapier',
			location_name: 'Name des Standorts',
			return_line_hint:
				'Die kleine Zeile über dem Anschriftfeld, die im Fensterumschlag zu sehen ist. Das Briefpapier setzt sie als {placeholder} ein und kann sie dort für alle Standorte in eine Form bringen.',
			place_hint: 'Der Ort in der Datumszeile.',
			phone_hint: 'Die Telefonnummer im Kontaktblock oben rechts. Leer steht dort die Nummer des Hauptstandorts.',
			sample_recipient: 'Kanzlei Muster & Partner\nMusterstraße 1\n47533 Kleve',
			sample_subject: 'Zusammenarbeit in der Erbenermittlung',
			sample_salutation: 'Sehr geehrte Damen und Herren,',
			sample_body:
				'So sieht ein Brief auf diesem Briefpapier aus. Der Text kommt aus dem Schriftverkehr der Kanzlei, alles andere auf dieser Seite stellen Sie hier ein.',
			sample_closing: 'Mit freundlichen Grüßen',
		},
		calendar: {
			title: 'Kalender',
		},
		law_firms: {
			title: 'Kanzleien',
			pipeline_title: 'Onboarding-Pipeline',
			board: 'Pipeline',
			list: 'Liste',
			closed_hint: '{count} Kanzleien sind ruhend oder verloren und werden im Board nicht gezeigt.',
			drop_hint: 'Karte in eine andere Spalte ziehen, um den Status zu ändern.',
			backlog_hint:
				'Bewusst zurückgestellt, wird über die Wiedervorlage von selbst wieder fällig. Nicht zu verwechseln mit ruhend - dort ist der Kontakt beendet.',
			required_open: 'Es sind noch Pflichtschritte offen.',
		},
		law_firm: {
			title: 'Kanzlei',
			delete_blocked: 'Kanzlei mit Fällen kann nicht gelöscht werden - stattdessen auf Ruhend setzen.',
			master_data: 'Stammdaten',
			address: 'Anschrift',
			contact: 'Kontakt',
			pipeline: 'Pipeline',
			progress: 'Onboarding: {done} von {total}',
			no_contacts: 'Noch kein Ansprechpartner hinterlegt.',
			no_matters: 'Für diese Kanzlei ist noch kein Fall angelegt.',
			no_communications: 'Noch kein Schreiben an diese Kanzlei.',
			communications_failed: 'Der Schriftverkehr konnte nicht geladen werden.',
			date_sent: 'versendet',
			date_created: 'angelegt',
			communication_locked: 'Versendet - Bearbeiten und Löschen gesperrt',
		},
		matters: {
			title: 'Fälle',
			open_only: 'Nur offene',
		},
		matter: {
			title: 'Fall',
			delete_blocked:
				'Nur ein offener Fall ohne Dateien und ohne weitere Personen neben dem Erblasser kann gelöscht werden - jeder andere wird abgeschlossen.',
			decedent: 'Erblasser',
			court: 'Nachlassgericht',
			fee: 'Honorar',
			dates: 'Termine',
			closed_hint: 'Der Fall ist abgeschlossen und schreibgeschützt.',
			no_log: 'Noch kein Kontakt dokumentiert.',
			dropzone: {
				hint: 'Dateien hier ablegen',
				browse: 'oder klicken, um Dateien auszuwählen',
				uploading: 'Dateien werden hochgeladen',
				filed_as: 'Wird abgelegt als: {category}',
				too_large: 'Groesser als {size}',
				failed: 'Upload fehlgeschlagen',
				retry: 'Wiederholen | Einen Upload wiederholen | {count} Uploads wiederholen',
				clear: 'Liste leeren',
			},
		},
		family_tree: {
			title: 'Stammbaum',
			delete_blocked:
				'Der Erblasser kann nicht gelöscht werden - zuerst im Fall einen anderen Erblasser auswählen.',
			generation: 'Generation {n}',
			unplaced: 'Nicht zugeordnet',
			unplaced_hint: 'Diese Personen hängen an keinem Zweig des Erblassers.',
			no_decedent: 'Für diesen Fall ist kein Erblasser gesetzt.',
			legend: 'Legende',
			share: 'Erbquote',
			relation: 'Verhältnis',
			select_parent: 'Elternteil auswählen',
			no_selection: 'Eine Person im Stammbaum auswählen, um Details, Aufgaben und Dateien zu sehen.',
			no_documents: 'Zu dieser Person ist keine Datei abgelegt.',
			cyclic: 'Diese Verknüpfung würde einen Kreis erzeugen.',
		},
		heir_chart: {
			title: 'Erbenchart',
			in_the_estate_of: 'In der Nachlasssache {name}',
			reference: 'Aktenzeichen',
			decedent: 'Erblasser',
			court: 'Nachlassgericht',
			court_reference: 'Aktenzeichen des Gerichts',
			born_on: 'geboren am {date}',
			died_on: 'gestorben am {date}',
			place_and_date: '{place}, den {date}',
			born_name: '(geb. {name})',
			dashed_hint: 'Gestrichelt: Adoptiv-, Stief- oder ungeklaerte Abstammung',
			register: 'Beteiligtenverzeichnis',
			column_generation: 'Gen.',
			column_name: 'Name',
			column_state: 'Recherchestand',
			footnote: 'Die Erbquoten sind von Hand erfasst, nicht berechnet.',
		},
	},

	modals: {
		law_firm: {
			create: 'Kanzlei anlegen',
			edit: 'Kanzlei bearbeiten',
			location_hint: 'Gilt auch für die Fälle dieser Kanzlei und bestimmt die Absendeadresse ihrer Briefe.',
			section_origin: 'Herkunft und Notiz',
			section_create: 'Beim Anlegen',
		},
		location: {
			create: 'Standort anlegen',
			edit: 'Standort bearbeiten',
			letterhead_hint:
				'Briefpapier dieses Standorts. Nur diese vier Felder unterscheiden sich zwischen den Standorten, alles andere steht unter Administration > Briefpapier.',
		},
		contact: {
			create: 'Ansprechpartner anlegen',
			edit: 'Ansprechpartner bearbeiten',
		},
		matter: {
			create: 'Fall anlegen',
			edit: 'Fall bearbeiten',
			decedent_hint: 'Der Erblasser wird als Wurzel des Stammbaums angelegt.',
			decedent_edit_hint: 'Dieselbe Person wie im Stammbaum - eine Korrektur hier steht auch dort.',
			decedent_select_hint:
				'Der Erblasser ist die Wurzel des Stammbaums und wird nur hier gewechselt - das nummeriert jede Generation neu.',
			decedent_none: 'Der Stammbaum hat noch keine Personen, aus denen ein Erblasser gewählt werden könnte.',
			close: {
				text: '"{item}" wird abgeschlossen und für die Bearbeitung gesperrt. Er kann jederzeit wieder geöffnet werden.',
			},
		},
		person: {
			create: 'Person anlegen',
			edit: 'Person bearbeiten',
			section_relation: 'Verwandtschaft und Erbquote',
		},
		document: {
			create: 'Datei hochladen',
			edit: 'Datei bearbeiten',
			preview: {
				close: 'Schließen',
				open_tab: 'In neuem Tab öffnen',
				download: 'Herunterladen',
				not_previewable: 'Dieses Format lässt sich nicht anzeigen, nur herunterladen.',
				no_file: 'Zu diesem Eintrag ist keine Datei gespeichert.',
			},
		},
		interaction: {
			create: 'Kontakteintrag anlegen',
			edit: 'Kontakteintrag bearbeiten',
		},
		correspondence_template: {
			create: 'Vorlage anlegen',
			edit: 'Vorlage bearbeiten',
			once_hint: 'Höchstens ein Entwurf je Kanzlei, wie beim Anschreiben.',
			active_hint: 'Nur aktive Vorlagen stehen im Schriftverkehr zur Auswahl.',
			locked_hint:
				'Das Anschreiben bleibt aktiv und einmal je Kanzlei: Kanzlei-Formular und Recherche-Import legen es über seinen Schlüssel an. Text und Betreff sind frei.',
			section_text: 'Brieftext',
			text_hint:
				'Absätze durch eine Leerzeile trennen. Anrede und Grußformel werden je Kanzlei ergänzt, der erste Absatz setzt die Anrede fort.',
			gap_hint:
				'erscheint im Entwurf rot und muss vor dem Versand ersetzt oder gelöscht werden - auch für Absätze, die nur manchmal passen, etwa "Nur bei Auslandsbezug - sonst Absatz löschen".',
			placeholders: {
				firm: 'Name der Kanzlei',
				city: 'Ort der Kanzlei',
				office: 'Standort',
				salutation: 'Anrede, je Kontakt',
				date: 'Heutiges Datum',
				note: 'Individueller Bezug, sonst eine rote Lücke',
			},
		},
		tag: {
			create: 'Tag anlegen',
			edit: 'Tag bearbeiten',
			remove: {
				title: 'Tag löschen?',
				text: '"{item}" wird gelöscht. | "{item}" wird gelöscht und von einer Kanzlei entfernt. | "{item}" wird gelöscht und von {count} Kanzleien entfernt.',
			},
		},
		communication: {
			create: 'Schreiben anlegen',
			edit: 'Schreiben bearbeiten',
			section_letter: 'Brieftext',
			section_blocks: 'Anschrift und Absender',
			blocks_hint:
				'Nur für dieses Schreiben gespeichert - eine Korrektur hier ändert die Kanzlei und das Briefpapier nicht.',
			outreach_hint:
				'Entwirft das Erstanschreiben aus der Vorlage. Der Text ist ein Entwurf und will vor dem Versand gelesen werden.',
			generate_hint:
				'Entwirft ein Schreiben aus einer Vorlage. Der Text ist ein Entwurf und will vor dem Versand gelesen werden.',
			generate_used: 'Diese Vorlage wird nur einmal je Kanzlei verwendet und wurde bereits entworfen.',
			mark_sent: {
				title: 'Als versendet vermerken?',
				text: '"{item}" wird schreibgeschützt und im Kontaktverlauf eingetragen.',
			},
			review: {
				title: 'Schreiben freigeben?',
				text: 'Ist "{item}" gelesen und alles in Ordnung? Danach ist es freigegeben und kann versendet werden.',
			},
			review_gaps: {
				title: 'Noch Platzhalter im Schreiben',
				text: '"{item}" beinhaltet noch Platzhalter und Formulierungsvorschläge. Erst ausfüllen, dann freigeben.',
			},
			reviewed_hint: 'Freigegeben. Eine Änderung am Text setzt es zurück auf Entwurf, es muss dann neu freigegeben werden.',
			closing_placeholder: 'Leer: die Grußformel des Briefpapiers',
		},
		task: {
			create: 'Aufgabe anlegen',
			edit: 'Aufgabe bearbeiten',
			outreach_hint: 'Legt beim Speichern die Aufgabe "Kanzlei anschreiben" an.',
		},
		remove: {
			title: 'Wirklich löschen?',
			text: '"{item}" wird dauerhaft entfernt.',
		},
	},

	data: {
		task: {
			id: 'Nr.',
			title: 'Aufgabe',
			description: 'Beschreibung',
			kind: 'Art',
			due_at: 'Fällig',
			completed_at: 'Erledigt',
			assigned_to: 'Zuständig',
			subject: 'Bezug',
			state: 'Status',
		},
		calendar_event: {
			task: 'Aufgabe',
			follow_up: 'Wiedervorlage',
			matter_deadline: 'Fallfrist',
			onboarding_step: 'Onboarding-Schritt',
		},
		law_firm: {
			id: 'Nr.',
			name: 'Name',
			type: 'Typ',
			priority: 'Priorität',
			location: 'Standort',
			location_none: 'Kein Standort',
			tags: 'Tags',
			city: 'Ort',
			zip: 'PLZ',
			street: 'Straße',
			street_number: 'Nr.',
			country: 'Land',
			phone: 'Telefon',
			email: 'E-Mail',
			website: 'Webseite',
			onboarding_state: 'Status',
			follow_up_at: 'Wiedervorlage',
			source: 'Quelle',
			summary: 'Notiz',
			owner: 'Betreuer',
			matters_count: 'Fälle',
			onboarding_progress: 'Onboarding',
		},
		contact: {
			salutation: 'Anrede',
			title: 'Titel',
			first_name: 'Vorname',
			last_name: 'Nachname',
			role: 'Funktion',
			email: 'E-Mail',
			phone: 'Telefon',
			mobile: 'Mobil',
			is_primary: 'Hauptkontakt',
			remark: 'Bemerkung',
		},
		matter: {
			id: 'Nr.',
			reference: 'Aktenzeichen',
			title: 'Bezeichnung',
			law_firm: 'Kanzlei',
			location: 'Standort',
			decedent: 'Erblasser',
			court_name: 'Nachlassgericht',
			court_reference: 'Az. Gericht',
			state: 'Status',
			opened_at: 'Auftragsdatum',
			deadline_at: 'Frist',
			closed_at: 'Abgeschlossen',
			fee_model: 'Honorarmodell',
			fee_value: 'Honorarwert',
			summary: 'Zusammenfassung',
			assigned_to: 'Bearbeiter',
			persons_count: 'Personen',
			documents_count: 'Dateien',
		},
		person: {
			first_name: 'Vorname',
			last_name: 'Nachname',
			birth_name: 'Geburtsname',
			gender: 'Geschlecht',
			born_at: 'Geboren am',
			born_place: 'Geburtsort',
			died_at: 'Gestorben am',
			died_place: 'Sterbeort',
			last_residence: 'Letzter Wohnort',
			life_state: 'Lebensstatus',
			research_state: 'Ermittlungsstand',
			relation_label: 'Verhältnis zum Erblasser',
			share: 'Erbquote',
			share_numerator: 'Zähler',
			share_denominator: 'Nenner',
			remark: 'Bemerkung',
			parents: 'Eltern',
			children: 'Kinder',
		},
		document: {
			title: 'Bezeichnung',
			category: 'Kategorie',
			document_date: 'Datum',
			issuer: 'Ausstellende Stelle',
			person: 'Person',
			no_person: 'Ohne Person',
			uploaded_by: 'Hochgeladen von',
			created_at: 'Hochgeladen am',
			size: 'Größe',
			remark: 'Bemerkung',
			file: 'Datei',
		},
		interaction: {
			happened_at: 'Datum',
			kind: 'Art',
			subject: 'Betreff',
			body: 'Text',
			user: 'Erfasst von',
			contact: 'Ansprechpartner',
		},
		location: {
			name: 'Standort',
			is_default: 'Hauptstandort',
			law_firms_count: 'Kanzleien',
		},
		letterhead: {
			contact_title: 'Bezeichnung des Standorts',
			contact_address: 'Anschrift (eine Zeile je Zeile)',
			return_line: 'Absenderzeile',
			place: 'Ort',
			phone: 'Telefon',
			location_name: 'Name des Standorts',
			groups: {
				data: 'Standort',
			},
		},
		correspondence_template: {
			name: 'Name',
			description: 'Beschreibung',
			channel: 'Weg',
			subject: 'Betreff',
			body: 'Text',
			postscript: 'PS',
			once_per_firm: 'Einmal je Kanzlei',
			is_active: 'Aktiv',
			sort: 'Reihenfolge',
		},
		tag: {
			key: 'Schlüssel',
			name: 'Name',
			color: 'Farbe',
			description: 'Beschreibung',
			sort: 'Reihenfolge',
			law_firms_count: 'Kanzleien',
		},
		communication: {
			channel: 'Weg',
			state: 'Status',
			subject: 'Betreff',
			salutation: 'Anrede',
			body: 'Text',
			closing: 'Grußformel',
			postscript: 'PS',
			text_size: 'Schriftgröße Brieftext',
			recipient_block: 'Empfänger',
			sender_block: 'Absender',
			contact: 'Ansprechpartner',
			date: 'Datum',
			user: 'Verfasst von',
		},
		onboarding_step: {
			label: 'Schritt',
			is_required: 'Pflicht',
			due_at: 'Fällig',
			completed_at: 'Erledigt',
			completed_by: 'Erledigt von',
			remark: 'Bemerkung',
		},
		enum: {
			law_firm_priority: {
				a: 'A',
				b: 'B',
				c: 'C',
				none: 'Keine',
			},
			law_firm_type: {
				law_firm: 'Kanzlei',
				estate_administrator: 'Nachlasspflegschaft',
				probate_court: 'Nachlassgericht',
				notary: 'Notariat',
				other: 'Sonstige',
			},
			onboarding_state: {
				new: 'Neu',
				lead: 'Lead',
				contacted: 'Kontaktiert',
				meeting: 'Termin',
				agreement: 'Vereinbarung',
				active: 'Aktiv',
				backlog: 'Backlog',
				dormant: 'Ruhend',
				lost: 'Verloren',
			},
			matter_state: {
				intake: 'Aufnahme',
				research: 'Ermittlung',
				evidence: 'Nachweisführung',
				negotiation: 'Verhandlung',
				settlement: 'Abwicklung',
				closed: 'Abgeschlossen',
				aborted: 'Abgebrochen',
			},
			fee_model: {
				quota: 'Erfolgsquote',
				hourly: 'Stundensatz',
				flat: 'Pauschale',
				mixed: 'Kombiniert',
			},
			life_state: {
				alive: 'Lebend',
				deceased: 'Verstorben',
				unknown: 'Unbekannt',
			},
			research_state: {
				assumed: 'Vermutet',
				researching: 'In Ermittlung',
				confirmed: 'Ermittelt',
				excluded: 'Ausgeschlossen',
				unreachable: 'Nicht erreichbar',
			},
			relation_kind: {
				biological: 'Leiblich',
				adoptive: 'Adoptiert',
				step: 'Stief',
				unknown: 'Unbekannt',
			},
			union_kind: {
				marriage: 'Ehe',
				civil_partnership: 'Lebenspartnerschaft',
				unmarried: 'Ohne Trauschein',
			},
			document_category: {
				certificate: 'Urkunde',
				correspondence: 'Schriftverkehr',
				evidence: 'Nachweis',
				court: 'Gericht',
				internal: 'Intern',
				other: 'Sonstiges',
			},
			task_kind: {
				manual: 'Aufgabe',
				outreach: 'Anschreiben',
				triage: 'Sichtung',
				follow_up: 'Wiedervorlage',
				research: 'Recherche',
				document: 'Unterlage',
			},
			interaction_kind: {
				call: 'Telefonat',
				email: 'E-Mail',
				letter: 'Brief',
				meeting: 'Termin',
				internal: 'Intern',
			},
			communication_channel: {
				letter: 'Brief',
				email: 'E-Mail',
			},
			letter_text_size: {
				normal: 'Normal (10,5 pt)',
				compact: 'Kompakt (10 pt)',
				small: 'Klein (9,5 pt)',
			},
			communication_state: {
				draft: 'Entwurf',
				ready: 'Freigegeben',
				sent: 'Versendet',
			},
		},
	},
};
